<template id="winnerList">
    <v-ons-page>
        <v-ons-toolbar class="toolbarBack">
            <div class="left">
                <v-ons-toolbar-button @click="$router.push('/'+$route.params.questionId+'/detail')" class="back-icon"></v-ons-toolbar-button>
            </div>
            <div class="center toolbar-alignMent">
                <div>
                    <img class="verticallyMiddle" alt="quiz-image" src="../assets/hamropatro.png"
                         style="width: 22px;height: 22px"/>
                </div>
                <div class="predictWinWrapper">&nbsp;{{text.information}}</div>
            </div>
            <div class="right" v-if="allResponse">

            </div>
            <div v-else class="right">
                <v-ons-toolbar-button class="refresh" @click="refresh()"></v-ons-toolbar-button>
            </div>
        </v-ons-toolbar>
        <v-ons-pull-hook
                :action="pullItems"
                @changestate="state = $event.state"
        >
            <span v-show="state === 'initial'">
                <v-ons-progress-circular class="refreshButton circularPad"
                                         value="20"></v-ons-progress-circular>
            </span>
            <span v-show="state === 'preaction'">
                <v-ons-progress-circular class="refreshButton circularPad"
                                         value="40"></v-ons-progress-circular>
            </span>
            <span v-show="state === 'action'">
                <v-ons-progress-circular class="refreshButton circularPad"
                                         value="100"></v-ons-progress-circular>
            </span>
        </v-ons-pull-hook>
        <v-ons-toast :visible.sync="showSnack">
            {{snackBarMsg}}
            <button @click="showSnack = false"><i class="zmdi zmdi-close"></i>
            </button>
        </v-ons-toast>
        <p class="text-center">
            <v-ons-progress-circular class="refreshButton" indeterminate v-if="loading"></v-ons-progress-circular>
        </p>
        <div>
            <div class="detailPage" v-if="allResponse">
                <div v-if="quizDetail.status==='Result'">
                    <div class="text-center colorWhite" style="font-size: 16px; font-weight: 600" v-bind:key="option" v-for="(option,key) in quizOptions">
                        <div>
                            <div><img v-if="quizDetail.correctOption===option" src="../assets/winner_gold.png" style="border-radius: 50%; width: 20px; height: 20px; padding-right: 5px; vertical-align: middle"/>{{option}}</div>
                            <div v-if="key<Object.keys(quizOptions).length-1">Vs</div>
                        </div>
                    </div>
                    <div class="marginLeftRightNone"
                         style="overflow: hidden;margin-top: 15px"
                         v-for="(value,key,index) in quizDetail.reward">
                        <div class="winnerBottom">
                            <div class="winnerPrize">{{value.name}}</div>
                        </div>
                        <div>
                            <div class="" v-if="quizDetail.status==='Result'" style="padding: 10px 0">
                                <v-ons-list-item v-for="(item) in allResponse.winners[key+1]" :class="item.participant.user.userID===userId?'winnerUser':''">
                                    <div class="right" style="background: none;display: inline" v-if="item.participant.user.userID===userId">
                                        <v-ons-toolbar-button class="chat-icon" style="margin: 0" @click="$router.push('/chat/'+userId)"></v-ons-toolbar-button>
                                    </div>
                                    <div class="left">
                                        <div>
                                            <img v-if="item.participant.user.img" class="list-item__thumbnail" :src="item.participant.user.img" style="border-radius: 50%">
                                            <span style="background: #e5e5e5; border-radius: 50%; padding: 5px 9px;" v-else>{{firstLetter(item.participant.user.name)}}</span>
                                            <span class="winnerTop-right x2Item" v-if="item.participant.x2Entry">2x</span>
                                        </div>
                                    </div>
                                    <div class="center list-item__center list-item--material__center">
                                        <span class="list-item__subtitle colorWhite" style="font-size: 16px; line-height: 1.7">{{item.participant.user.name}}</span>
                                    </div>

                                </v-ons-list-item>
                            </div>
                        </div>
                    </div>
                    <div class="text-center colorWhite">
                        <div>
                            <span style="font-weight: 600">{{text.congratulationMSG}}</span>
                        </div>
                        <br>
                        <div>
                                        <span class="font14px">
                                            {{text.additionalText}}
                                        </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="detailPage colorWhite" v-else><div>{{text.details}}</div></div>
        </div>
    </v-ons-page>
</template>

<script>
    import {getQuizDetail} from '../api/requests/questions';
    import {getUserID} from "../util/globalConfig";
    import usedText from "../util/languageText";
    export default {
        name: "WinnerList",
        data: () => ({
            // forSnackbar
            showSnack: null,
            snackBarMsg: null,
            loading: true,
            quizDetail: null,
            state: 'initial',
            quizId: null,
            allResponse: null,
            quizOptions:[],
            userId: getUserID(),
            text:usedText
        }),
        created() {
            this.getItems();
        },
        methods: {
            getItems() {
                //remove snackBar
                let self = this;
                this.getQuizById();
                setTimeout(function () {
                    self.showSnack = false;
                }, 2000);
            },
            getQuizById: function () {
                let self = this;
                self.loading = true;
                self.showSnack = false;
                self.allResponse = '';
                self.quizId = self.$route.params.questionId;
                getQuizDetail(self.quizId,3).then(function (response) {
                    self.loading = false;
                    let allOptions=[];
                    if (response.success) {
                        self.allResponse = response.data;
                        self.quizDetail = self.allResponse.quiz;
                        self.quizDetail.options.forEach(function (option) {
                            if(!option.includes('Draw') && !option.includes('Cancelled')){
                                allOptions.push(option)
                            }
                        });
                        self.quizOptions=allOptions;

                    } else {
                        // show SnackBar
                        // self.snackBarMsg = response.msg;
                        // self.showSnack = true;
                    }
                }).catch(function (error) {
                    self.loading = false;
                    // show SnackBar
                    // self.snackBarMsg = error.data.msg;
                    // self.showSnack = true;
                });
            },
            refresh () {
                this.getItems();
            },
            pullItems(done) {
                setTimeout(() => {
                    this.loading = true;
                    this.getItems();
                    done();
                }, 500);
            },
        },
    }
</script>